import { useState } from "react";
import {
  ALL_SHAPE_TYPES,
  SHAPE_LABELS,
  type ShapeType,
} from "../../nodes/shapes/index";
import { SHAPE_LUCIDE_ICON } from "./canvasToolbarIcon";
import {
  CanvasToolbarButton,
  CanvasToolbarGroup,
  CanvasToolbarSubmenu,
} from "./index";

interface CanvasShapeSwapMenuProps {
  currentShape: ShapeType;
  onShapeChange: (shape: ShapeType) => void;
  onOpenChange?: (open: boolean) => void;
}

/** Swap-shape Type-1 submenu for the shape contextual toolbar. */
export function CanvasShapeSwapMenu({
  currentShape,
  onShapeChange,
  onOpenChange,
}: CanvasShapeSwapMenuProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    onOpenChange?.(next);
  };

  return (
    <CanvasToolbarSubmenu
      open={open}
      onOpenChange={handleOpenChange}
      side="top"
      trigger={
        <CanvasToolbarButton
          label="Swap shape"
          dropdown
          active={open}
          aria-expanded={open}
        >
          <ShapeIcon shapeType={currentShape} />
        </CanvasToolbarButton>
      }
    >
      <CanvasToolbarGroup>
        {ALL_SHAPE_TYPES.map((shapeType) => (
          <CanvasToolbarButton
            key={shapeType}
            label={SHAPE_LABELS[shapeType]}
            active={currentShape === shapeType}
            onClick={() => {
              onShapeChange(shapeType);
              handleOpenChange(false);
            }}
          >
            <ShapeIcon shapeType={shapeType} />
          </CanvasToolbarButton>
        ))}
      </CanvasToolbarGroup>
    </CanvasToolbarSubmenu>
  );
}

function ShapeIcon({ shapeType }: { shapeType: ShapeType }) {
  const Icon = SHAPE_LUCIDE_ICON[shapeType];
  return <Icon className="size-4" strokeWidth={1.75} />;
}
